import { useState } from "react";
import PageHeader from "../../components/AdminSideComponents/common/PageHeader";
import Products from "../../components/AdminSideComponents/products/Products";
import ProductInquiry from "../../components/AdminSideComponents/products/ProductInquiry";

const AdminProducts = () => {
  const [activeTab, setActiveTab] = useState("product");

  return (
    <div className="p-6">
      {/* PAGE HEADER WITH TABS */}
      <PageHeader
        title="Product"
        breadcrumb="Dashboard / Products"
        customSection={
          <div className="flex gap-4">
            <button
              onClick={() => setActiveTab("product")}
              className={`pb-2 px-4 font-medium ${
                activeTab === "product"
                  ? "border-b-2 border-pink-500 text-pink-500"
                  : "text-gray-500"
              }`}
            >
              Product
            </button>

            <button
              onClick={() => setActiveTab("inquiry")}
              className={`pb-2 px-4 font-medium ${
                activeTab === "inquiry"
                  ? "border-b-2 border-pink-500 text-pink-500"
                  : "text-gray-500"
              }`}
            >
              Product Inquiry
            </button>
          </div>
        }
      />

      {/* TAB CONTENT */}
      <div className="mt-6">
        {activeTab === "product" && <Products />}
        {activeTab === "inquiry" && <ProductInquiry />}
      </div>
    </div>
  );
};

export default AdminProducts;
